import * as Sentry from '@sentry/react';

const DSN = import.meta.env.VITE_SENTRY_DSN as string | undefined;

/**
 * No-op without a DSN (local default — `.env.example` ships it empty).
 * Errors only: no performance/profiling traces, no session replay (E-15).
 */
export function initSentry() {
  if (!DSN) return;

  Sentry.init({
    dsn: DSN,
    environment: (import.meta.env.VITE_SENTRY_ENVIRONMENT as string | undefined) || 'local',
    release: (import.meta.env.VITE_RELEASE as string | undefined) || undefined,
    tracesSampleRate: 0,
    // send_default_pii-equivalent: identify() below sends only id/role/merchant_id,
    // never contact info — mirrors the backend's SentryUserContext middleware.
    sendDefaultPii: false,
  });
}

export function setSentryUser(user: { id: number; role: string; merchant_id: number | null } | null) {
  if (!DSN) return;

  if (user === null) {
    Sentry.setUser(null);
    return;
  }

  Sentry.setUser({
    id: String(user.id),
    role: user.role,
    merchant_id: user.merchant_id === null ? null : String(user.merchant_id),
  });
}

export { Sentry };
